import login from '@/api/login';

import * as types from '../mutation-types';

const state = {
  userInfo: {},
  perms: []
};

const getters = {
  userInfo: state => state.userInfo,
  perms: state => state.perms
};

const mutations = {
  [types.SET_USERINFO](state, {
    userInfo
  }) {
    state.userInfo = userInfo;
  },
  [types.SET_USER_PERMS](state, {
    perms
  }) {
    state.perms = perms;
  }
};

const actions = {
  // code 模式登录(外部传入 code，后端调 EIAM 换 AD)
  userCodeLogin({
    commit,
    dispatch
  }, payload) {
    return new Promise((resolve, reject) => {
      login.userCodeLogin(payload)
        .then((response) => {
          if(response.code == 200) {      
            response.result.userInfo.loginDeparts = [];
            response.result.userInfo.loginMedicalFields = [];      
            response.result.userInfo.loginTeams = [];  

            response.result.userInfo.departIdList.sort((a,b) => a>b?1:-1).forEach(d => {
              response.result.userInfo.loginDeparts.push({
                id: d,
                departName: d
              })
            });
              
            response.result.userInfo.medicalFieldList.sort((a,b) => a>b?1:-1).forEach(d => {
              response.result.userInfo.loginMedicalFields.push({
                id: d,
                medicalFieldName: d
              })
            });

            if(response.result.userInfo.teamField) {
              response.result.userInfo.loginTeams = response.result.userInfo.teamField.split(',').map(t => {
                return {
                  'id': t,
                  'teamName': t
                }
              });
            }

            commit(types.SET_USERINFO, {
              userInfo: response.result.userInfo
            });
            commit(types.SET_USER_PERMS, {perms : response.result.permissionList});
          }
          resolve(response);
        }, (error) => {
          reject(error);
        });
    });
  },

  // p_token 模式(兼容保留)
  userTokenLogin({
    commit,
    dispatch
  }, payload) {
    return new Promise((resolve, reject) => {
      login.userTokenLogin(payload)
        .then((response) => {
          if(response.code == 200) {
            response.result.userInfo.loginDeparts = [];
            response.result.userInfo.loginMedicalFields = [];
            response.result.userInfo.loginTeams = [];

            response.result.userInfo.departIdList.sort((a,b) => a>b?1:-1).forEach(d => {
              response.result.userInfo.loginDeparts.push({
                id: d,
                departName: d
              })
            });

            response.result.userInfo.medicalFieldList.sort((a,b) => a>b?1:-1).forEach(d => {
              response.result.userInfo.loginMedicalFields.push({
                id: d,
                medicalFieldName: d
              })
            });

            if(response.result.userInfo.teamField) {
              response.result.userInfo.loginTeams = response.result.userInfo.teamField.split(',').map(t => {
                return {
                  'id': t,
                  'teamName': t
                }
              });
            }

            commit(types.SET_USERINFO, {
              userInfo: response.result.userInfo
            });
            commit(types.SET_USER_PERMS, {perms : response.result.permissionList});
          }
          resolve(response);
        }, (error) => {
          reject(error);
        });
    });
  },

  userCookieLogin({
    commit,

    dispatch
  }, payload) {
    return new Promise((resolve, reject) => {
      login.userCookieLogin(payload)
        .then((response) => {
          if (response.code == 200) {    
            response.result.userInfo.loginDeparts = [];
            response.result.userInfo.loginMedicalFields = [];       
            response.result.userInfo.loginTeams = [];  

            response.result.userInfo.departIdList.sort((a,b) => a>b?1:-1).forEach(d => {
              response.result.userInfo.loginDeparts.push({
                id: d,
                departName: d
              })
            });
              
            response.result.userInfo.medicalFieldList.sort((a,b) => a>b?1:-1).forEach(d => {
              response.result.userInfo.loginMedicalFields.push({
                id: d,
                medicalFieldName: d
              })
            });

            if(response.result.userInfo.teamField) {
              response.result.userInfo.loginTeams = response.result.userInfo.teamField.split(',').map(t => {
                return {
                  'id': t,
                  'teamName': t
                }
              });
            }

            commit(types.SET_USERINFO, {
              userInfo: response.result.userInfo
            });
            commit(types.SET_USER_PERMS, {perms : response.result.permissionList});
          }
          resolve(response);
        }, (error) => {
          reject(error);
        });
    });
  },

  getUserInfo({ //login 接口已包含userInfo信息，此接口不会被调用
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      login.getUserInfo(payload)
        .then((response) => {
          response.result.userInfo.meetingApproveRole = payload.result.userInfo.meetingApproveRole;
          response.result.userInfo.userCanEditDepart = response.result.userCanEditDepart;
          commit(types.SET_USERINFO, {
            userInfo: response.result.userInfo
          });
          resolve(response);
        }, (error) => {
          reject(error);
        });
    });
  }

};

export default {
  state,
  getters,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/login.js